module.exports = __webpack_public_path__ + "static/media/arugula.2ba8f362.jpg";